import './AdminSearch.scss'
import React, {Component} from 'react'
import {withTranslation} from 'react-i18next'
import moment from 'moment'
import apiConfig from '../../config/api'
import {Badge, Form, Icon, Pagination, Spin, Table, Button, Modal, Checkbox, Progress, notification, Tooltip, Input} from 'antd'
import {ReportService} from '../../services'
import {AdminSearchFilters} from './components'
import {getSearchesPromise, exportSearchesPromise, updateStatusSearchPromise, getBusqHistOCPromise, saveCommentOCPromise} from './promises'
import {camelizerHelper} from '../../helpers'
import {PdfModal} from '../../layouts/Private/components'
import { UploadProgressService } from '../../services'
import i18n from '../../config/i18next'

class AdminSearch extends Component {

    initialFiltersState = {
        search: '',
        searchFiltersDate: 'ALL',
        searchFiltersStatus: null,
        searchFiltersDateFrom: '',
        searchFiltersDateTo: '',
        searchFiltersHasReport: 'ALL',
        searchFiltersMode: 'ALL',
        searchFiltersOutcome: 'ALL',
        searchFiltersTypeIsRut: true,
        searchFiltersUser: '',
        searchFiltersType: null
    }

    state = {
        isLoading: true,
        isLoadingReport: false,
        isLoadingReportZip: false,
        search: this.initialFiltersState.search,
        searchFiltersDate: this.initialFiltersState.searchFiltersDate,
        searchFiltersDateFrom: this.initialFiltersState.searchFiltersDateFrom,
        searchFiltersDateTo: this.initialFiltersState.searchFiltersDateTo,
        searchFiltersStatus: this.initialFiltersState.searchFiltersStatus,
        searchFiltersHasReport: this.initialFiltersState.searchFiltersHasReport,
        searchFiltersMode: this.initialFiltersState.searchFiltersMode,
        searchFiltersOutcome: this.initialFiltersState.searchFiltersOutcome,
        searchFiltersTypeIsRut: this.initialFiltersState.searchFiltersTypeIsRut,
        searchFiltersUser: this.initialFiltersState.searchFiltersUser,
        searchFiltersType: this.initialFiltersState.searchFiltersType,
        searchResults: [],
        searchResultsCurrentPage: 1,
        searchResultsFromNum: 0,
        searchResultsPerPage: 10,
        searchResultsTotalNum: -1,
        isModalVisible: false,
        certificadosResults: [],
        showModalPdf: false,
        pdfSource: '',
        isPdfObj: false,
        chkAll: false,
        selectedItem: [],
        exporting: false,
        exportProgress: 0,
        exportError: null,
        exportStage: null // null = no exportando, 1 = extrayendo, 2 = generando, 'downloading' = descargando
    }

    async componentDidMount() {
        this.getFirstSearchResults()
    }

    componentWillUnmount() {
        if (this.exportEventSource) {
            try { this.exportEventSource.close() } catch (e) { /* ignore */ }
            this.exportEventSource = null
        }
    }

    async getFirstSearchResults() {
        this.handlePaginationOnChange(1)
    }

    async handlePaginationOnChange(currentPage) {
        const filters = this.getFilters()
        const {searchResultsPerPage} = this.state
        const fromNum = ((currentPage - 1) * searchResultsPerPage)

        await this.setState({isLoading: true, searchResultsFromNum: fromNum})

        const searchResults = await getSearchesPromise(fromNum, searchResultsPerPage, filters)

        await this.setState({
            isLoading: false,
            searchResults: searchResults.records,
            searchResultsCurrentPage: currentPage,
            searchResultsTotalNum: searchResults.total
        })
    }

    handleSelectDeselectAll(e) {
		this.setState({chkAll: e.target.checked})
        if(!e.target.checked){
            this.setState({selectedItem: []})
        }else{
            let selectedIds = [];
            this.state.searchResults.map(i => selectedIds.push(i.id))
            this.setState({selectedItem: selectedIds});
        }
	}

    async openShowComments(record) {
        let history = []

        try {
            const response = await getBusqHistOCPromise(record.id)
            if (Array.isArray(response)) {
                history = response
            } else if (response && Array.isArray(response.records)) {
                history = response.records
            } else if (response && Array.isArray(response.data)) {
                history = response.data
            }
        } catch (e) {
            history = []
        }

        let commentsModal

        const CommentsModalContent = () => {
            const [msg, setMsg] = React.useState('')
            const trimmedMsg = msg.trim()

            return (
                <div>
                    <div style={{maxHeight: 320, overflowY: 'auto', marginBottom: 12, border: '1px solid #f0f0f0', borderRadius: 4, padding: 4}}>
                        {history.length > 0
                            ? history.map((item, index) => {
                                const comment = item && item.comment ? item.comment : '-'
                                const user = item && item.usuario ? (item.usuario.userName || item.usuario.name || '') : ''
                                const status = item && item.status ? this.props.t('messages.aml.searches.status.' + item.status) : ''
                                const date = item.dateShortAsString
                                const leftMeta = [user, status].filter(Boolean).join(' - ')

                                return (
                                    <div
                                        key={item && item.id ? item.id : `hist-${index}`}
                                        style={{
                                            marginBottom: 8,
                                            padding: '8px 10px',
                                            borderBottom: index < history.length - 1 ? '1px solid #f0f0f0' : 'none',
                                            backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff',
                                            borderRadius: 4
                                        }}
                                    >
                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#8c8c8c', marginBottom: 2}}>
                                            <span>{leftMeta}</span>
                                            <span>{date}</span>
                                        </div>
                                        <div style={{width: '100%', whiteSpace: 'normal', wordBreak: 'break-word'}}>{comment}</div>
                                    </div>
                                )
                            })
                            : <small style={{color: '#8c8c8c'}}>{this.props.t('messages.aml.noComments')}</small>
                        }
                    </div>

                    <div style={{borderTop: '1px solid #e8e8e8', margin: '10px 0 12px 0', paddingTop: 10}}>
                        <div style={{color: '#8c8c8c', marginBottom: 6}}>{this.props.t('messages.aml.comment')}</div>
                    </div>

                    <Input.TextArea
                        rows={5}
                        maxLength={500}
                        placeholder={this.props.t('messages.aml.comment')}
                        onChange={(e) => { setMsg(e.target.value) }}
                    />

                    <div style={{marginTop: 8, textAlign: 'right'}}>
                        <Button
                            type="primary"
                            disabled={!trimmedMsg}
                            onClick={() => {
                                Modal.confirm({
                                    title: this.props.t('messages.aml.confirmation'),
                                    content: this.props.t('messages.aml.confirm.SAVE_COMMENT'),
                                    cancelText: this.props.t('messages.aml.cancel'),
                                    onOk: () => {
                                        saveCommentOCPromise(record.id, trimmedMsg)
                                            .then(() => {
                                                commentsModal.destroy()
                                                notification.success({
                                                    message: this.props.t('messages.aml.save')
                                                })
                                            })
                                            .catch(() => {
                                                notification.error({
                                                    message: this.props.t('messages.aml.error'),
                                                    description: this.props.t('messages.aml.updateStatusError'),
                                                });
                                            })
                                    }
                                })
                            }}
                        >
                            {this.props.t('messages.aml.save')}
                        </Button>
                    </div>
                </div>
            )
        }

        commentsModal = Modal.info({
            title: this.props.t('messages.aml.comments'),
            width: 800,
            okText: this.props.t('messages.aml.btnClose'),
            cancelText: this.props.t('messages.aml.cancel'),
            content: <CommentsModalContent />
        })
    }

    async handleAuthorize(recordId, status) {
        let msg = ''

        Modal.confirm({
            title: this.props.t('messages.aml.confirmation'),
            width: 600,
            cancelText: this.props.t('messages.aml.cancel'),
            content: (
                <div>
                    <p>{this.props.t(`messages.aml.confirm.${status}`)}</p>
                    <Input.TextArea
                        rows={5}
                        maxLength={500}
                        placeholder={this.props.t('messages.aml.comment')}
                        onChange={(e) => { msg = e.target.value }}
                    />
                </div>
            ),
            onOk: () => {
                updateStatusSearchPromise({id: recordId, status, msg})
                .then(() => {
                    setTimeout(() => {
                        this.handleSubmitPagination(this.state.searchResultsCurrentPage)
                    }, 1000)
                })
                .catch(() => {
                    notification.error({
                        message: this.props.t('messages.aml.error'),
                        description: this.props.t('messages.aml.updateStatusError'),
                    });
                })
            }
        })
    }

    renderTableColumns() {
        const {t, modulo} = this.props
        const isAuthSearch = modulo === 'auth-search'

        const tableColumns = [
            {
				title: () => (
					<div>
						<Checkbox onChange={e => this.handleSelectDeselectAll(e)} checked={this.state.chkAll}/>
					</div>
				),
				width: '5%',
				align: 'center',
				render: (record) => {
                    if (record.certificados !== null && record.certificados.length > 0) {
                        return <Checkbox
                                    checked={this.state.selectedItem.filter(i => i === record.id).length > 0 || this.state.chkAll}
                                    onChange={e => {
                                        this.setState({chkAll: false})
                                        let checkedItem = [...this.state.selectedItem]
                                        if(e.target.checked) {
                                            checkedItem.push(record.id)
                                        }else{
                                            checkedItem = checkedItem.filter(i => i !== record.id)
                                        }
                                        this.setState({selectedItem: checkedItem});
                                    }}
                                />
                    }
				}
			},
            {
                title: t('messages.aml.date'),
                dataIndex: 'dateShortAsString'
            },
            {
                title: t('messages.aml.username'),
                dataIndex: 'userName'
            },
            {
                title: t('messages.aml.databases'),
                dataIndex: 'modulos',
                ellipsis: true
            },
            {
                title: t('messages.aml.rut'),
                dataIndex: 'rut'
            },
            {
                title: t('messages.aml.name'),
                dataIndex: 'nombre',
                ellipsis: true
            }
        ]
        if(!isAuthSearch) {
            tableColumns.push(
                {
                    title: t('messages.aml.results'),
                    dataIndex: 'resultados'
                }
            )
        }
        tableColumns.push(
            {
                title: isAuthSearch ? t('messages.aml.status') : t('messages.aml.mode'),
                dataIndex: isAuthSearch ? 'status' : 'modo',
                render: (text) => isAuthSearch ? t(`messages.aml.searches.status.${text}`, {defaultValue: '--'}) : text
            },
            {
                title: t('messages.aml.certificates'),
                dataIndex: 'certificados',
                render: (certificados, record) => {
                    if (certificados !== null && certificados.length > 0) {
                        if (certificados.length === 1) {
                            return <Button size="small" type="primary" className="pdfButton"
                                        onClick={(e) => this.handlePDFReport(record.id, certificados[0].pdf)}>PDF <Icon
                                type="cloud-download"/></Button>
                        } else {
                            return <Button size="small" type="primary" className="pdfButton"
                                        onClick={(e) => this.openModalReport(record)}>PDF&nbsp;<Badge size="small"
                                        count={certificados.length}/></Button>
                        }
                    } else if (record.modo === 'BATCH') {
                        return <Button size="small" type="primary" className="pdfButton"
                                    onClick={(e) => this.handlePDFBatch(record)}>PDF <Icon
                            type="cloud-download"/></Button>
                    }
                }
            }
        )

        if(isAuthSearch) {
            tableColumns.push({
                title: t('messages.aml.actions'),
                className: 'actions-column',
                onHeaderCell: () => ({ style: { whiteSpace: 'nowrap' } }),
                onCell: () => ({ style: { whiteSpace: 'nowrap' } }),
                render: (record) => {
                    return (
                            <div style={{whiteSpace: 'nowrap'}}>
                                <Tooltip title={t('messages.aml.comments')}>
                                    <Button size="small" icon="message" onClick={() => this.openShowComments(record)}></Button>
                                </Tooltip>
                                { record.status === 'PENDIENTE' &&
                                <>
                                    <Tooltip title={t('messages.aml.authorize')}>
                                        <Button size="small" icon="check-circle" type="primary" onClick={() => this.handleAuthorize(record.id, 'APROBADO')} style={{marginLeft: 6}}></Button>
                                    </Tooltip>
                                     <Tooltip title={t('messages.aml.reject')}>
                                        <Button size="small" icon="close-circle" onClick={() => this.handleAuthorize(record.id, 'RECHAZADO')} style={{marginLeft: 6}}></Button>
                                    </Tooltip>
                                </>
                                }
                            </div>
                    )
                }
            })
        }

        return tableColumns
    }

    closeHandlerPdfModal() {
        this.setState({
            showModalPdf: false
        })
    }

    async handlePDFBatch(record) {
        await this.setState({isLoadingReport: true, showModalPdf: false})
        const obj = await ReportService.pdfToObj('/pdfBatch', {id: record.batchId, lang: i18n.language}, null, 'batch.pdf')
        this.setState({
            showModalPdf: true,
            pdfSource: obj.data,
            isPdfObj: true,
            isLoadingReport: false
        })
    }

    renderCertificadosTableColumns() {
        const {t} = this.props

        const tableColumns = [
            {
                title: t('messages.aml.rut'),
                dataIndex: 'rut',
                size: 120
            },
            {
                title: t('messages.aml.name'),
                dataIndex: 'nombre',
                render: (text) => camelizerHelper(text),
                size: 420
            },
            {
                title: t('messages.aml.certificate'),
                dataIndex: 'pdf',
                size: 120,
                render: (pdf, certificado) => {
                    return <Button
                                type="primary"
                                onClick={(e) => this.handlePDFReport(certificado.searchId, certificado.pdf)}>PDF <Icon
                                type="cloud-download"/>
                            </Button>
                }
            }
        ]

        return tableColumns
    }

    openModalReport(record) {
        for (let i = 0; i < record.certificados.length; i++) {
            record.certificados[i]['searchId'] = record.id
        }
        this.setState({isModalVisible: true, certificadosResults: record.certificados})
    }

    handleModalCancel() {
        this.setState({isModalVisible: false})
    }

    handleOnChangeDate(searchFiltersDate) {
        this.setState({searchFiltersDate})
    }

    handleOnChangeStatus(searchFiltersStatus) {
        this.setState({searchFiltersStatus})
    }

    handleOnChangeDateFrom(searchFiltersDateFrom) {
        this.setState({searchFiltersDateFrom: moment(searchFiltersDateFrom).format('DD/MM/YYYY')})
    }

    handleOnChangeDateTo(searchFiltersDateTo) {
        this.setState({searchFiltersDateTo: moment(searchFiltersDateTo).format('DD/MM/YYYY')})
    }

    handleOnChangeMode(e) {
        this.setState({searchFiltersMode: e.target.value})
    }

    handleOnChangeHasReport(e) {
        this.setState({searchFiltersHasReport: e.target.value})
    }

    handleOnChangeSearch(e) {
        this.setState({search: e.target.value})
    }

    handleOnChangeSearchOutcome(e) {
        this.setState({searchFiltersOutcome: e.target.value})
    }

    handleOnChangeSearchTypeIsRut(searchFiltersTypeIsRut) {
        this.setState({searchFiltersTypeIsRut})
    }

    handleOnChangeUser(searchFiltersUser) {
        this.setState({searchFiltersUser})
    }

    handleOnChangeType(searchFiltersType) {
        this.setState({searchFiltersType})
    }

    async handleExcelReport() {
        if (this.exportEventSource) {
            try { this.exportEventSource.close() } catch (e) { /* ignore */ }
            this.exportEventSource = null
        }
        const exportFilters = {
            ...this.getFilters(),
            from: 0,
            size: 1000000
        }
        await this.setState({
            exporting: true,
            exportProgress: 0,
            exportError: null,
            isLoadingReport: true,
            exportStage: null
        })
        try {
            const response = await exportSearchesPromise(exportFilters)
            if (response && response.batchId) {
                this.listenExportProgress(response.batchId)
            } else {
                await this.setState({exportError: 'No se pudo iniciar la exportación', isLoadingReport: false})
            }
        } catch (e) {
            await this.setState({exportError: 'No se pudo iniciar la exportación', isLoadingReport: false})
        }
    }

    async handlePdfCert() {
        const {t} = this.props
        await this.setState({isLoadingReportZip: true})
        await ReportService.read('/pdfSearches', {ids:this.state.selectedItem}, null, 'certificados-'+moment().format('DD-MM-YYYY HH:mm:ss')+'.zip', null, t)
        await this.setState({isLoadingReportZip: false})
    }

    async handlePDFReport(searchId, pdf) {
        await this.setState({isLoadingReport: true, showModalPdf: false})
        const obj = await ReportService.pdfToObj('/certificate', {searchId, pdf}, null, 'report.pdf')
        this.setState({
            showModalPdf: true,
            pdfSource: obj.data,
            isPdfObj: true,
            isLoadingReport: false
        })
    }

    handleCancelExport() {
        if (this.exportEventSource) {
            try { this.exportEventSource.close() } catch (e) { /* ignore */ }
            this.exportEventSource = null
        }
        this.setState({
            exporting: false,
            exportProgress: 0,
            exportError: null,
            exportStage: null,
            isLoadingReport: false
        })
    }

    handleExportConnectionError(message) {
        if (this.exportEventSource) {
            try { this.exportEventSource.close() } catch (e) { /* ignore */ }
            this.exportEventSource = null
        }
        this.setState({
            exportError: message || 'Error de conexión en progreso',
            exporting: false,
            isLoadingReport: false,
            exportStage: null
        })
    }

    listenExportProgress(batchId) {
        const {t} = this.props
        this.exportEventSource = UploadProgressService.listenProgress(
            batchId,
            {
                onProgress: (progressData) => {
                    const value = progressData.progress || 0
                    const stage = progressData.stage
                    this.setState((prev) => {
                        const nextProgress = (prev.exportStage !== stage && stage === 2) ? 0 : value
                        const changed =
                            prev.exportProgress !== nextProgress ||
                            prev.exportStage !== stage
                        return changed ? {exportProgress: nextProgress, exportStage: stage} : null
                    })

                    if (progressData.status === 'ERROR') {
                        this.handleExportConnectionError(progressData.message || 'Error al exportar busquedas')
                        return
                    }
                },
                onComplete: async (progressData) => {
                    const fileName = progressData.fileName || 'busquedas.xlsx'
                    this.setState({
                        exportStage: 'downloading',
                        exportProgress: 100
                    })
                    try {
                        await ReportService.read('/inputFile', {path: "reportes/busquedas/" + batchId + ".xlsx", "remove": true}, null, fileName, null, t)
                    } finally {
                        this.setState({
                            exporting: false,
                            exportProgress: 0,
                            exportError: null,
                            exportStage: null,
                            isLoadingReport: false
                        })
                    }
                },
                onInactivity: () => {
                    notification.warning({
                        message: t('messages.aml.warning'),
                        description: t('messages.aml.downloadInactivity'),
                    });
                },
                onError: (error) => {
                    this.handleExportConnectionError('Conexión perdida durante la exportación. Inténtalo nuevamente.')
                }
            }
        )
    }

    // Descarga automática al finalizar; no se necesita modal ni manejo manual

    handleOnClickRestoreFilters() {
        this.setState({
            search: this.initialFiltersState.search,
            searchFiltersDate: this.initialFiltersState.searchFiltersDate,
            searchFiltersDateFrom: this.initialFiltersState.searchFiltersDateFrom,
            searchFiltersDateTo: this.initialFiltersState.searchFiltersDateTo,
            searchFiltersStatus: this.initialFiltersState.searchFiltersStatus,
            searchFiltersHasReport: this.initialFiltersState.searchFiltersHasReport,
            searchFiltersMode: this.initialFiltersState.searchFiltersMode,
            searchFiltersOutcome: this.initialFiltersState.searchFiltersOutcome,
            searchFiltersTypeIsRut: this.initialFiltersState.searchFiltersTypeIsRut,
            searchFiltersUser: this.initialFiltersState.searchFiltersUser,
            searchFiltersType: this.initialFiltersState.searchFiltersType,
            searchResultsCurrentPage: 1,
            searchResultsFromNum: 0,
            searchResultsPerPage: 10,
            searchResultsTotalNum: -1
        })
        this.handleSubmit()
    }

    getFilters() {
        const {modulo, currentUser} = this.props
        const filters = {}

        if(modulo === 'auth-search' && currentUser.cliente.modules.includes('AUTH-SEARCH')) {
            filters.oc = "Y"
        }

        for (let key in this.initialFiltersState) {
            let value = this.state[key]
            if (key === 'search') {
                if (value !== '') {
                    if (this.state['searchFiltersTypeIsRut']) {
                        filters['rut'] = value
                    } else {
                        filters['name'] = value
                    }
                }
            }
            if (key === 'searchFiltersStatus') {
                filters['status'] = value
            }
            if (key === 'searchFiltersDate') {
                filters['optDates'] = value
                if (value === 'RANGE') {
                    filters['fromDate'] = this.state['searchFiltersDateFrom']
                    filters['toDate'] = this.state['searchFiltersDateTo']
                }
            }

            if (key === 'searchFiltersUser') {
                filters['userId'] = value
            }

            if (key === 'searchFiltersType') {
                filters['type'] = value
            }

            if (key === 'searchFiltersOutcome') {
                filters['hasResults'] = value
            }

            if (key === 'searchFiltersHasReport') {
                filters['hasReport'] = value
            }

            if (key === 'searchFiltersMode') {
                filters['modo'] = value
            }
        }
        return filters
    }

    handleSubmit() {
        this.handleSubmitPagination(1)
    }

    async handleSubmitPagination(currentPage) {
        this.handlePaginationOnChange(currentPage)
    }

    render() {


        const {
            isLoading,
            isLoadingReport,
            isLoadingReportZip,
            search,
            searchFiltersDate,
            searchFiltersStatus,
            searchFiltersDateFrom,
            searchFiltersDateTo,
            searchFiltersHasReport,
            searchFiltersMode,
            searchFiltersOutcome,
            searchFiltersUser,
            searchFiltersType,
            searchFiltersTypeIsRut,
            searchResults,
            searchResultsCurrentPage,
            searchResultsTotalNum,
            searchResultsPerPage,
            isModalVisible,
            certificadosResults,
            showModalPdf,
            pdfSource,
            isPdfObj,
            selectedItem,
            exporting,
            exportProgress,
            exportError,
            exportStage
        } = this.state

        const {currentUser, t} = this.props

        return (
            <div className="admin-search">
                <Modal
                    visible={exporting || !!exportError}
                    footer={null}
                    onCancel={this.handleCancelExport.bind(this)}
                    maskClosable={false}
                >
                    {exportError ? (
                        <div>
                            <p style={{color: 'red'}}>{exportError}</p>
                        </div>
                    ) : (
                        <div>
                            <p>
                                {exportStage === 'downloading'
                                    ? t('messages.aml.downloadingFile') 
                                    : exportStage === 1 
                                        ? t('messages.aml.extractingData')
                                        : exportStage === 2 
                                            ? t('messages.aml.generatingReport')
                                            : t('messages.aml.exporting') + '...'}
                            </p>
                            <Progress percent={Math.round(exportProgress)} />
                            { exportStage === 'downloading' &&
                                <center style={{padding:10}}><Spin spinning={true}/></center>
                            }
                        </div>
                    )}
                </Modal>
                <AdminSearchFilters currentUser={currentUser}
                                    selectedItem = {selectedItem}
                                    isLoadingReportZip = {isLoadingReportZip}
                                    defaultValues={{
                                        search,
                                        searchFiltersDate,
                                        searchFiltersDateFrom,
                                        searchFiltersDateTo,
                                        searchFiltersHasReport,
                                        searchFiltersMode,
                                        searchFiltersOutcome,
                                        searchFiltersUser,
                                        searchFiltersType,
                                        searchFiltersTypeIsRut,
                                        searchFiltersStatus
                                    }}
                                    onChangeDateHandler={this.handleOnChangeDate.bind(this)}
                                    onChangeStatusHandler={this.handleOnChangeStatus.bind(this)}
                                    onChangeDateFromHandler={this.handleOnChangeDateFrom.bind(this)}
                                    onChangeDateToHandler={this.handleOnChangeDateTo.bind(this)}
                                    onChangeHasReportHandler={this.handleOnChangeHasReport.bind(this)}
                                    onChangeModeHandler={this.handleOnChangeMode.bind(this)}
                                    onChangeSearchHandler={this.handleOnChangeSearch.bind(this)}
                                    onChangeSearchOutcomeHandler={this.handleOnChangeSearchOutcome.bind(this)}
                                    onChangeSearchTypeIsRutHandler={this.handleOnChangeSearchTypeIsRut.bind(this)}
                                    onChangeUserHandler={this.handleOnChangeUser.bind(this)}
                                    onChangeTypeHandler={this.handleOnChangeType.bind(this)}
                                    onClickRestoreFiltersHandler={this.handleOnClickRestoreFilters.bind(this)}
                                    onClickExportHandler={this.handleExcelReport.bind(this)}
                                    onClickPdfHandler={this.handlePdfCert.bind(this)}
                                    onSubmit={this.handleSubmit.bind(this)}
                                    modulo={this.props.modulo}
                />

                <div className="table-wrapper">
                    {isLoading ?
                        <Spin spinning={true} size="large"/>
                        :
                        <Table dataSource={searchResults} columns={this.renderTableColumns()} pagination={false}
                                loading={isLoadingReport} size="small"/>
                    }
                </div>

                <Pagination current={searchResultsCurrentPage}
                        total={searchResultsTotalNum}
                        pageSize={searchResultsPerPage}
                        onChange={this.handleSubmitPagination.bind(this)}
                        size="small"
                        showTotal={(total, range) => `${range[0]}-${range[1]} ${t('messages.aml.of')} ${total} ${t('messages.aml.entries')}`}/>

                { isModalVisible &&
                    <Modal visible={true} title="Certificados" width="640px"
                        onCancel={this.handleModalCancel.bind(this)}
                        footer={<Button type="primary" onClick={this.handleModalCancel.bind(this)}>Cerrar</Button>}>
                        <Table dataSource={certificadosResults} columns={this.renderCertificadosTableColumns()}
                            pagination={false} size="small"/>
                    </Modal>
                }

                {showModalPdf && 
                    <PdfModal closeHandler={this.closeHandlerPdfModal.bind(this)} pdfSource={pdfSource} embeded={true} isObj ={isPdfObj}/>
                }
            </div>
        )
    }
    }

export default Form.create({ name: 'searches' })(withTranslation()(AdminSearch))
